module.exports = __webpack_public_path__ + "img/trello.077f8db3.jpg";